'use strict';
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
var $p;
/** @constructor */
function $c_Lpresto_AuditView$AuditEntry(id, at, user, email, origin, action, entity, ref, target, added, removed, scope) {
  this.Cq = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$L0;
  this.Cn = null;
  this.JL = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$L0;
  this.Co = null;
  this.wQ = null;
  this.Cm = null;
  this.Cp = null;
  this.Cr = null;
  this.wS = null;
  this.tL = null;
  this.tM = null;
  this.wR = null;
  this.Cq = id;
  this.Cn = at;
  this.JL = user;
  this.Co = email;
  this.wQ = origin;
  this.Cm = action;
  this.Cp = entity;
  this.Cr = ref;
  this.wS = target;
  this.tL = added;
  this.tM = removed;
  this.wR = scope;
}
export { $c_Lpresto_AuditView$AuditEntry as $c_Lpresto_AuditView$AuditEntry };
$p = $c_Lpresto_AuditView$AuditEntry.prototype = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$h_O();
$p.constructor = $c_Lpresto_AuditView$AuditEntry;
/** @constructor */
function $h_Lpresto_AuditView$AuditEntry() {
}
export { $h_Lpresto_AuditView$AuditEntry as $h_Lpresto_AuditView$AuditEntry };
$h_Lpresto_AuditView$AuditEntry.prototype = $p;
$p.x = (function() {
  return new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_s_Product$$anon$1(this);
});
$p.p = (function() {
  var acc = (-889275714);
  acc = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sr_Statics$().o(acc, $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_T__hashCode__I("AuditEntry"));
  var $x_2 = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sr_Statics$();
  var $x_1 = acc;
  var t = this.Cq;
  acc = $x_2.o($x_1, $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sr_Statics$().bj(new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_RTLong(t.e, t.f)));
  acc = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sr_Statics$().o(acc, $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sr_Statics$().A(this.Cn));
  var $x_4 = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sr_Statics$();
  var $x_3 = acc;
  var t$1 = this.JL;
  acc = $x_4.o($x_3, $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sr_Statics$().bj(new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_RTLong(t$1.e, t$1.f)));
  acc = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sr_Statics$().o(acc, $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sr_Statics$().A(this.Co));
  acc = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sr_Statics$().o(acc, $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sr_Statics$().A(this.wQ));
  acc = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sr_Statics$().o(acc, $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sr_Statics$().A(this.Cm));
  acc = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sr_Statics$().o(acc, $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sr_Statics$().A(this.Cp));
  acc = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sr_Statics$().o(acc, $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sr_Statics$().A(this.Cr));
  acc = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sr_Statics$().o(acc, $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sr_Statics$().A(this.wS));
  acc = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sr_Statics$().o(acc, $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sr_Statics$().A(this.tL));
  acc = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sr_Statics$().o(acc, $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sr_Statics$().A(this.tM));
  acc = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sr_Statics$().o(acc, $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sr_Statics$().A(this.wR));
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sr_Statics$().ai(acc, 12);
});
$p.i = (function(x$0) {
  if ((this === x$0)) {
    return true;
  } else if ((x$0 instanceof $c_Lpresto_AuditView$AuditEntry)) {
    var this$1 = this.Cq;
    var b = x$0.Cq;
    if (((this$1.e === b.e) && (this$1.f === b.f))) {
      var this$2 = this.JL;
      var b$1 = x$0.JL;
      var $x_4 = ((this$2.e === b$1.e) && (this$2.f === b$1.f));
    } else {
      var $x_4 = false;
    }
    if ($x_4) {
      var x = this.Cn;
      var x$2 = x$0.Cn;
      var $x_3 = ((x === null) ? (x$2 === null) : x.i(x$2));
    } else {
      var $x_3 = false;
    }
    if ((((((($x_3 && (this.Co === x$0.Co)) && (this.wQ === x$0.wQ)) && (this.Cm === x$0.Cm)) && (this.Cp === x$0.Cp)) && (this.Cr === x$0.Cr)) && (this.wS === x$0.wS))) {
      var x$3 = this.tL;
      var x$4 = x$0.tL;
      var $x_2 = ((x$3 === null) ? (x$4 === null) : x$3.i(x$4));
    } else {
      var $x_2 = false;
    }
    if ($x_2) {
      var x$5 = this.tM;
      var x$6 = x$0.tM;
      var $x_1 = ((x$5 === null) ? (x$6 === null) : x$5.i(x$6));
    } else {
      var $x_1 = false;
    }
    if ($x_1) {
      var x$7 = this.wR;
      var x$8 = x$0.wR;
      return ((x$7 === null) ? (x$8 === null) : x$7.i(x$8));
    } else {
      return false;
    }
  } else {
    return false;
  }
});
$p.l = (function() {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sr_ScalaRunTime$().H(this);
});
$p.r = (function() {
  return 12;
});
$p.s = (function() {
  return "AuditEntry";
});
$p.j = (function(n) {
  switch (n) {
    case 0: {
      return this.Cq;
      break;
    }
    case 1: {
      return this.Cn;
      break;
    }
    case 2: {
      return this.JL;
      break;
    }
    case 3: {
      return this.Co;
      break;
    }
    case 4: {
      return this.wQ;
      break;
    }
    case 5: {
      return this.Cm;
      break;
    }
    case 6: {
      return this.Cp;
      break;
    }
    case 7: {
      return this.Cr;
      break;
    }
    case 8: {
      return this.wS;
      break;
    }
    case 9: {
      return this.tL;
      break;
    }
    case 10: {
      return this.tM;
      break;
    }
    case 11: {
      return this.wR;
      break;
    }
    default: {
      throw $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$ct_jl_IndexOutOfBoundsException__T__(new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_jl_IndexOutOfBoundsException(), ("" + n));
    }
  }
});
function $isArrayOf_Lpresto_AuditView$AuditEntry(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.D === depth)) && obj.$classData.B.n.hO)));
}
export { $isArrayOf_Lpresto_AuditView$AuditEntry as $isArrayOf_Lpresto_AuditView$AuditEntry };
var $d_Lpresto_AuditView$AuditEntry = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$TypeData().i($c_Lpresto_AuditView$AuditEntry, "presto.AuditView$AuditEntry", ({
  hO: 1,
  b: 1,
  c: 1,
  a: 1
}));
export { $d_Lpresto_AuditView$AuditEntry as $d_Lpresto_AuditView$AuditEntry };
//# sourceMappingURL=presto.-Audit-View$-Audit-Entry.js.map
